import { LogErrorFcn } from '@common/types';
import { datadogRum } from '@datadog/browser-rum';
import { isEnabled } from './datadog';

// N.B. Consider keeping this in sync with mobile/src/services/logging.ts
export const logError: LogErrorFcn = (
    error: unknown,
    context?: Record<string, unknown>
) => {
    if (isEnabled()) {
        datadogRum.addError(error, context);
    } else {
        console.error(error, context);
    }
};
